import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import InputTextField from "../../../components/input/inputTextField";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { createSearchParams, NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { SearchOutlined } from "@mui/icons-material";
import { ButtonPrimary } from "../../../components/button/ButtonCustoms";
import { dateTimeToView } from "../../../utils/date.utils";
import { debouncedApiCall } from "../../../utils/app.utils";
import FilterSelect from "../../../components/select/filterSelect";
import { MenuItem, useMediaQuery, useTheme } from "@mui/material";
import { icons } from "../../../assets/icons/icons";
import ModalSearchAdvisor from "./components/ModalSearchAdvisor";
import { InputValueNewAdvisor } from "../../../domains/advisor";
import { advisorApi } from "../../../api/advisor/advisor.api";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../components/alert/swal";
import { facultyApi } from "../../../api/factulty/factulty.api";

type Props = {};

const ManageAdvisor: React.FC<Props> = (props: Props) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const [dataAdvisor, setDataAdvisor] = useState<any[]>([]);
  const [singleDataAdvisor, setSingleDataAdvisor] = useState<any>();

  const [search, setSearch] = useState<string>("");
  const [isShowModalSearchAdvisor, setIsShowModalSearchAdvisor] =
    useState<boolean>(false);
  const [isShowModalUpdateSearchAdvisor, setIsShowModalUpdateSearchAdvisor] =
    useState<boolean>(false);
  const [isCanEdit, setIsCanEdit] = useState<boolean>(true);

  const [dataFaculty, setDataFaculty] = useState<any[]>([]);

  const [errorMessage, setErrorMessage] = useState<any[]>([]);

  const [inputValue, setInputValue] = useState<InputValueNewAdvisor>({
    advisor_id: 0,
    adv_fullname: "",
    adv_employee_id: "",

    adv_employee_no: "",
    adv_position: "",
    adv_position_name: "",
    adv_department: "",
    adv_department_name: "",
    start_date: new Date(),
    course: [],
    maximum_student: 0,
    evaluation_form: 0,
  });

  const [singleRawData, setSingleRawData] = useState<any[]>([]);

  const [selectedFaculties, setSelectedFaculties] = useState<any[]>([]);

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");

  const [inputValueSearch, setInputValueSearch] = useState({
    academic_year: "",
    degree: "",
    faculty: "",
    year: "",
    class: "",
  });

  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };


  const getDataAsvisors = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      id_faculty: inputValueSearch.faculty,
    };

    if (search) query = { ...query, search: search };

    const res = await advisorApi.getAllAdvisor(query);
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisor(data.data.items);
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
      setSelectedFaculties([]);
    } else {
      setDataAdvisor([]);
    }
  };

  const getDataFaculty = async () => {
    await facultyApi.listFaculty().then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataFaculty(data.data);
      } else {
        setDataFaculty([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  useEffect(() => {
    getDataFaculty();
  }, []);

  const handleDelete = async (id: number) => {
    if (id) {
      alertActive(
        "ลบอาจารย์ที่ปรึกษาวิทยานิพนธ์",
        "ท่านต้องการลบอาจารย์ที่ปรึกษาวิทยานิพนธ์ ใช่หรือไม่",
        undefined,
        undefined,
        async () => {
          dispatch(setLoading());
          await advisorApi
            .deleteAdvisor(+id)
            .then((res) => {
              if (res.status < 300) {
                alertSuccess(
                  "ลบอาจารย์ที่ปรึกษาวิทยานิพนธ์ เรียบร้อย",
                  undefined,
                  undefined,
                  () => {
                    getDataAsvisors();
                    setInputValue({
                      advisor_id: 0,
                      adv_fullname: "",
                      adv_employee_id: "",

                      adv_employee_no: "",
                      adv_position: "",
                      adv_position_name: "",
                      adv_department: "",
                      adv_department_name: "",
                      start_date: new Date(),
                      course: [],
                      maximum_student: 0,
                      evaluation_form: 0,
                    });
                  }
                );
              }
            })
            .catch(() => {
              alertError("ลบอาจารย์ที่ปรึกษาวิทยานิพนธ์ ไม่สำเร็จ");
            })
            .finally(() => {
              dispatch(unsetLoading());
            });
        }
      );
    }
    return;
  };

  const headCells = [
    {
      id: "employee_name",
      width: 40,
      disablePadding: true,
      align: "start",
      label: "ชื่อ - นามสกุล",
    },
    {
      id: "employee_no",
      disablePadding: true,
      width: 12,
      align: "center",
      label: "เลขประจำตัวเจ้าหน้าที่",
    },
    {
      id: "position",
      disablePadding: false,
      align: "center",
      width: 12,
      label: "ตำแหน่งงาน",
    },
    {
      id: "department",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "หน่วยงาน",
    },
    {
      id: "course",
      disablePadding: false,
      align: "start",
      width: 80,
      label: "หลักสูตร",
    },
    {
      id: "max_student_amount",
      disablePadding: false,
      align: "center",
      width: 40,
      label: "จำนวนที่รับนักศึกษาได้สูงสุด",
    },
    {
      id: "updated_by",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "ผู้ปรับปรุงล่าสุด",
    },
    {
      id: "last_updated",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "วันที่ปรับปรุงล่าสุด",
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 20,
      class: matches && dataAdvisor?.length > 0,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_advisor,
      // id_employee,
      first_name,
      last_name,
      employee_no,
      position_name,
      // id_department,
      department_name_th,
      // department_name_eng,
      faculty_names,
      number_students,
      first_name_create,
      last_name_create,
      // advisor_start_date,
      // first_name_modified,
      // last_name_modified,
      // count_advisor_req,
      // count_req_all,
      // id_advisor_form,
      modified_date,
      first_name_modified,
      last_name_modified,
      id_employee
    } = objData;


    const objRenderData = {
      key: id_advisor,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: first_name + " " + last_name,
        },
        {
          option: "TEXT",
          align: "start",
          label: employee_no || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: position_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: department_name_th || "-",
        },
        {
          option: "TEXT",
          align: "start",
          disablePadding: true,
          label:
            faculty_names && faculty_names.length > 0
              ? faculty_names.map((name: any, index: any) => (
                <React.Fragment key={index + 1}>
                  {index + 1}
                  {".) "}
                  {name}
                  {index < faculty_names.length - 1 && ", "}
                  <br />
                </React.Fragment>
              ))
              : "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: number_students,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: first_name_modified ? `${first_name_modified || ""} ${last_name_modified || ""}` : first_name_create + " " + last_name_create,
        },
        {
          option: "TEXT",
          align: "center",
          label: modified_date ? dateTimeToView(modified_date) : "-",
        },
        {
          option: "COMPONENT",
          align: "center",
          class: matches,
          component: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  navigate({
                    pathname: routeName.cms.manageAdvisors + `/${id_advisor}/detail`,
                    search: createSearchParams({
                      ...(id_employee ? { id_employee: id_employee.toString() } : {}),
                    }).toString()
                  });
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />

              <img
                onClick={() => {
                  setSingleDataAdvisor(objData);
                  setIsCanEdit(false);
                  setIsShowModalUpdateSearchAdvisor(true);
                  // setSelectedFaculties(faculty_names ?? []);
                  setInputValue({
                    ...inputValue,
                    advisor_id: id_advisor,
                    // adv_fullname: first_name + " " + last_name,
                    // adv_employee_id: id_employee,

                    // adv_employee_no: employee_no,
                    adv_position: position_name,
                    // adv_department: id_department,
                    // start_date: advisor_start_date,
                    // course: faculty_names,
                    // maximum_student: number_students,
                    // evaluation_form: 0,
                    // count_advisor_req: count_advisor_req,
                    // count_req_all: count_req_all,
                  });
                }}
                src={icons.edit}
                alt="edit"
                style={{ cursor: "pointer", margin: "0px 12px" }}
              />

              <img
                src={icons.bag_cross}
                alt="bag_cross"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleDelete(id_advisor);
                }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  useEffect(() => {
    getDataAsvisors();
  }, [page, pageLimit, sortBy, sortType, search, inputValueSearch]);

  const handleChangeValueSearch = (name: string, value: any) => {
    setInputValueSearch((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const validateForm = () => {
    const errors: string[] = [];

    // Check if required fields are empty
    if (!inputValue.adv_employee_id) {
      errors.push("adv_employee_id");
    }

    if (!inputValue.start_date) {
      errors.push("start_date");
    }

    if (!inputValue.course) {
      errors.push("course");
    }

    if (!inputValue.maximum_student) {
      errors.push("maximum_student");
    }

    if (!inputValue.evaluation_form) {
      errors.push("evaluation_form");
    }

    setErrorMessage(errors);

    // If there are no errors, return true
    return errors.length === 0;
  };

  const handleSave = async (dataBody: any, selectedFaculty: any) => {
    if (validateForm()) {
      try {
        dispatch(unsetLoading());

        // const degree_name = dataDegree.find(
        //   (item) => item.id_degree === inputValue.degree
        // );

        // const faculty_name = dataFaculty.find(
        //   (item) => item.id_faculty === inputValue.faculty
        // );

        const faculties = [
          ...selectedFaculty.map((item: any) => ({
            // id_advisor_faculty: 0,
            // id_advisor: 0,
            id_faculty: item.id_faculty,
            faculty_name: item.faculty_name,
            status: "active",
          })),
        ];

        const response = await advisorApi.createAdvisor({
          advisor: {
            id_employee: inputValue.adv_employee_id,
            first_name: inputValue.adv_fullname.split(" ")[0] ?? "",
            last_name: inputValue.adv_fullname.split(" ")[1] ?? "",
            id_department: inputValue.adv_department,
            employee_no: inputValue.adv_employee_no,
            advisor_start_date: inputValue.start_date,
            number_students: inputValue.maximum_student,
            id_advisor_form: inputValue.evaluation_form,
            status: "active",
          },
          advisor_faculty: faculties ?? [],
        });
        if (response.status < 300) {
          alertSuccess(
            "บันทึกอาจารย์ที่ปรึกษา",
            "บันทึกอาจารย์ที่ปรึกษา เรียบร้อยแล้ว",
            undefined,
            () => {
              getDataAsvisors();
              setIsCanEdit(false);
              setIsShowModalSearchAdvisor(false);
              setInputValue({
                advisor_id: 0,
                adv_fullname: "",
                adv_employee_id: "",

                adv_employee_no: "",
                adv_position: "",
                adv_position_name: "",
                adv_department: "",
                adv_department_name: "",
                start_date: new Date(),
                course: [],
                maximum_student: 0,
                evaluation_form: 0,
              });
            }
          );
        }
      } catch (error) {
        alertError("บันทึกอาจารย์ที่ปรึกษา ไม่สำเร็จ");
        setIsCanEdit(false);
      } finally {
        dispatch(unsetLoading());
        setIsCanEdit(false);
      }
    }
  };

  const processAdvisorFaculties = (
    oldData: Array<any>,
    newData: Array<any>,
    advisorId: number
  ) => {
    // Create a mapping of old data by `id_faculty` for quick lookup
    const oldDataMap = new Map(oldData.map((item) => [item.id_faculty, item]));

    // Prepare the final result
    const result = [];

    // Iterate through new data to handle matches and new entries
    for (const newItem of newData) {
      const matchingOldItem = oldDataMap.get(newItem.id_faculty);

      if (matchingOldItem) {
        // Matching data, combine old and new fields, and set status to active
        result.push({
          ...matchingOldItem,
          status: "active",
          id_advisor: advisorId, // Ensure id_advisor is added
        });

        // Remove the matched entry from oldDataMap
        oldDataMap.delete(newItem.id_faculty);
      } else {
        // New data, add with status active and id_advisor_faculty set to 0
        result.push({
          id_advisor_faculty: 0,
          id_advisor: advisorId,
          id_faculty: newItem.id_faculty,
          faculty_name: newItem.faculty_name,
          status: "active",
        });
      }
    }

    // Mark remaining old data as inactive
    for (const unmatchedOldItem of Array.from(oldDataMap.values())) {
      result.push({
        ...unmatchedOldItem,
        status: "inactive",
      });
    }

    return result;
  };

  const handleUpdate = async (dataBody: any, selectedFaculty: any) => {
    if (dataBody && inputValue && inputValue.advisor_id) {
      try {
        dispatch(unsetLoading());

        const handlefaculties = processAdvisorFaculties(
          singleRawData,
          selectedFaculty,
          +inputValue?.advisor_id
        );


        // const faculties = [
        //   ...selectedFaculty.map((item: any) => ({
        //     id_advisor_faculty: item.id_faculty,
        //     id_advisor: inputValue.advisor_id,
        //     id_faculty: item.id_faculty,
        //     faculty_name: item.faculty_name,
        //     status: "active",
        //   })),
        // ];

        const response = await advisorApi.updateAdvisor(
          inputValue.advisor_id ? inputValue.advisor_id : 0,
          {
            advisor: {
              id_advisor: inputValue.advisor_id,
              id_employee: inputValue.adv_employee_id,
              first_name: inputValue.adv_fullname.split(" ")[0] ?? "",
              last_name: inputValue.adv_fullname.split(" ")[1] ?? "",
              id_department: inputValue.adv_department,
              employee_no: inputValue.adv_employee_no,
              advisor_start_date: inputValue.start_date,
              number_students: inputValue.maximum_student,
              id_advisor_form: inputValue.evaluation_form,
              status: "active",
            },
            advisor_faculty: handlefaculties ?? [],
          }
        );
        if (response.status < 300) {
          alertSuccess(
            "แก้ไขอาจารย์ที่ปรึกษา",
            "แก้ไขอาจารย์ที่ปรึกษา เรียบร้อยแล้ว",
            undefined,
            () => {
              getDataAsvisors();
              setIsCanEdit(false);
              setIsShowModalUpdateSearchAdvisor(false);
              setInputValue({
                advisor_id: 0,
                adv_fullname: "",
                adv_employee_id: "",

                adv_employee_no: "",
                adv_position: "",
                adv_position_name: "",
                adv_department: "",
                adv_department_name: "",
                start_date: new Date(),
                course: [],
                maximum_student: 0,
                evaluation_form: 0,
              });
            }
          );
        }
      } catch (error) {
        alertError("แก้ไขอาจารย์ที่ปรึกษา ไม่สำเร็จ");
        setIsCanEdit(false);
      } finally {
        dispatch(unsetLoading());
        setIsCanEdit(false);
      }
    }
  };

  return (
    <div>
      <ModalSearchAdvisor
        setIsOpenModal={(isOpen: boolean) =>
          setIsShowModalSearchAdvisor(isOpen)
        }
        isOpenModal={isShowModalSearchAdvisor}
        inputValue={inputValue}
        setInputValue={setInputValue}
        action="create"
        setSelectedFaculties={setSelectedFaculties}
        selectedFaculties={selectedFaculties}
        handleSubmit={() => {
          handleSave(inputValueSearch, selectedFaculties);
        }}
        setIsCanEdit={(isDisable: boolean) => setIsCanEdit(isDisable)}
        isCanEdit={isCanEdit}
        errorMessage={errorMessage}
      />

      <ModalSearchAdvisor
        setIsOpenModal={(isOpen: boolean) =>
          setIsShowModalUpdateSearchAdvisor(isOpen)
        }
        isOpenModal={isShowModalUpdateSearchAdvisor}
        inputValue={inputValue}
        setInputValue={setInputValue}
        action="update"
        setSelectedFaculties={setSelectedFaculties}
        selectedFaculties={selectedFaculties}
        handleSubmit={() => {
          handleUpdate(inputValueSearch, selectedFaculties);
        }}
        setIsCanEdit={(isDisable: boolean) => setIsCanEdit(isDisable)}
        isCanEdit={isCanEdit}
        errorMessage={errorMessage}
        singleDataAdvisor={singleDataAdvisor}
        setSingleRawData={setSingleRawData}
      />

      <ContentHeading
        title={"จัดการอาจารย์ที่ปรึกษาวิทยานิพนธ์"}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-12">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหาชื่อ - นามสกุล/เลขประจำตัวเจ้าหน้าที่"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        {/* <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.academic_year ?? ""}
            labelId="academic_year-id"
            selectId="academic_year-select-id"
            options={[
              {
                id_academic_year: "",
                academic_year_name: "ทุกปีการศึกษา",
              },
            ].map((list, index) => (
              <MenuItem value={list.id_academic_year} key={index + 1}>
                {list.academic_year_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("academic_year", e.target.value)
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
          <FilterSelect
            heading={""}
            value={inputValueSearch.degree ?? ""}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChangeValueSearch("degree", e.target.value);
              getDataFacalty();
            }}
            disabled={!isCanEdit}
            options={[
              {
                id_degree: "",
                degree_name: "ทุกระดับ",
              },
              ...dataDegree.map((item, index) => ({
                id_degree: item.id_degree, // Ensure year is a string
                degree_name: item.degree_name,
              })),
            ].map((option: any, index: number) => (
              <MenuItem value={option.id_degree} key={index + 1}>
                {option.degree_name}
              </MenuItem>
            ))}
            labelId={""}
            selectId={""}
          />
        </article> */}

        <article className="w-full col-span-12 lg:col-span-4 md:col-span-3 sm:col-span-12">
          <FilterSelect
            heading={""}
            value={inputValueSearch.faculty ?? ""}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChangeValueSearch("faculty", e.target.value);
            }}
            options={[
              {
                id_faculty: "",
                faculty_name: "ทุกหลักสูตร",
              },
              ...dataFaculty.map((item, index) => ({
                id_faculty: item.id_faculty, // Ensure year is a string
                // faculty_name: item.faculty_name,
                faculty_name:
                  item.faculty_name.length > 35
                    ? item.faculty_name.slice(0, 35) + "..."
                    : item.faculty_name,
              })),
            ].map((option: any, index: number) => (
              <MenuItem value={option.id_faculty} key={index + 1}>
                {option.faculty_name}
              </MenuItem>
            ))}
            labelId={""}
            selectId={""}
          />
        </article>

        <article
          className="w-full col-span-12 lg:col-span-5 md:col-span-4 sm:col-span-12"
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <ButtonPrimary
            onClick={() => {
              setInputValue({
                advisor_id: 0,
                adv_fullname: "",
                adv_employee_id: "",

                adv_employee_no: "",
                adv_position: "",
                adv_position_name: "",
                adv_department: "",
                adv_department_name: "",
                start_date: new Date(),
                course: [],
                maximum_student: 0,
                evaluation_form: 0,
              });
              setIsCanEdit(true);
              setIsShowModalSearchAdvisor(true);
            }}
            mode="add"
            buttonName={"เพิ่มอาจารย์ที่ปรึกษา"}
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={2000}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataAdvisor &&
            dataAdvisor.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default ManageAdvisor;
